import React from 'react';
import { useIntl } from 'react-intl';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { OwnerBillingInformationIcons } from '../../../../components/Common/Assets/SvgIconComponent/SideMenuIcons';
import messages from '../../../../locale/jsonMessages';
import { getOptionLineLabel } from '../../../../helpers/bookingOptionsPresentation';

const RenterBillingInformation = ({
    optionLines, convertCurrency, discount, total,
    discountType, serviceFee, claimRefund,
    pricingData, refundToGuest, refundCurrency, serviceFeeType, serviceFeeValue, securityDeposit,
    promoCode, promoDiscount
}) => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.renterBillingInformation)} icon={<OwnerBillingInformationIcons />}>
                <ViewTableBodyInformation
                    title={formatMessage(messages.rentalPrice)}
                    pricingData={pricingData}
                />
                {/* Booking options (delivery included) are already part of the total: shown here, never added again. */}
                {(optionLines || []).map((line, index) => (
                    <React.Fragment key={line.id || `${line.code}-${index}`}>
                        <ViewTableBodyInformation
                            title={getOptionLineLabel(line, formatMessage)}
                            currencyData
                            amount={Number(line.amount) || 0}
                            convertCurrency={convertCurrency}
                        />
                        {line.code === 'delivery' && line.userInput && <ViewTableBodyInformation
                            title={formatMessage(messages.boDeliveryLocationShown)}
                            value={line.userInput}
                        />}
                    </React.Fragment>
                ))}
                {discount > 0 && <ViewTableBodyInformation
                    title={discountType}
                    currencyData
                    amount={discount}
                    convertCurrency={convertCurrency}
                    isMinus
                />}
                {promoDiscount > 0 && <ViewTableBodyInformation
                    title={promoCode}
                    currencyData
                    amount={promoDiscount}
                    convertCurrency={convertCurrency}
                    isMinus
                />}
                {serviceFee > 0 && <ViewTableBodyInformation
                    title={`${formatMessage(messages.serviceFee)} ${(serviceFeeType != 'fixed' && Number(serviceFeeValue) > 0) ? '(' + serviceFeeValue?.toFixed(2) + '%)' : ''} `}
                    currencyData
                    amount={serviceFee}
                    convertCurrency={convertCurrency}
                />}
                {securityDeposit > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.securityDeposit)}
                    currencyData
                    amount={securityDeposit}
                    convertCurrency={convertCurrency}
                />}
                {total > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.total)}
                    currencyData
                    amount={total}
                    convertCurrency={convertCurrency}
                    isBold
                />}
                {refundToGuest > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.refundAmount)}
                    currencyData
                    amount={refundToGuest}
                    convertCurrency={refundCurrency}
                    isBold
                />}
                {claimRefund > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.securityDepositToGuest)}
                    currencyData
                    amount={claimRefund}
                    convertCurrency={convertCurrency}
                    isBold
                />}
            </ViewTableInformation>
        </div>
    )
}

export default RenterBillingInformation;

